import { LastItemPurchasesOrderColumn } from '@/core/domain/purchase/Purchase.types';
import { Radio } from 'antd';
import React from 'react';

interface PurchaseDateOrderSelectorProps {
  defaultValue?: LastItemPurchasesOrderColumn;
  onChange: (value: LastItemPurchasesOrderColumn) => void;
  label?: string;
}

export const PurchaseDateOrderSelector: React.FC<
  PurchaseDateOrderSelectorProps
> = ({
  defaultValue = LastItemPurchasesOrderColumn.RELEASE_DATE,
  onChange,
  label = 'Ordenar por',
}) => {
  return (
    <div style={{ marginBottom: '1.25rem' }}>
      <div>{label}</div>

      <Radio.Group
        optionType="button"
        buttonStyle="solid"
        defaultValue={defaultValue}
        onChange={(e) => onChange(e.target.value)}
      >
        <Radio value={LastItemPurchasesOrderColumn.RELEASE_DATE}>
          Data de lançamento
        </Radio>
        <Radio value={LastItemPurchasesOrderColumn.ISSUE_DATE}>
          Data de emissão
        </Radio>
      </Radio.Group>
    </div>
  );
};
